import {
    setPremiumTemporarilyEnabled,
    startPremiumPreviewTimeBased,
} from '../actions/trialActions';
import getStore from '../store/store';
import { orchestrator } from 'satcheljs';
import { updateSettingDirectly } from '../actions/updateSettingDirectly';
import { now, addDays, userDate, OwaDate } from 'owa-datetime';

/**
 * Triggered when first time user click 'try now'
 */
orchestrator(startPremiumPreviewTimeBased, actionMessage => {
    const store = getStore();
    let finalDatePremiumDemo = store.userOptions.finalDatePremiumDemo;
    // this value should always be null at this point
    if (!finalDatePremiumDemo) {
        const endDate: OwaDate = userDate(addDays(now(), actionMessage.daysLeft));
        updateSettingDirectly('finalDatePremiumDemo', endDate.toString());
        setPremiumTemporarilyEnabled(true);
    }
});
